export interface IApiExportResponse {
    url: string;
    format: ExportFormats;
    name: string;
}


export enum ExportFormats {
    XLS = 'xls',
    XLSX = 'xlsx',
    HTML = 'html',
}
